export function startIdentityLogin(platformUrl, email) {
    const url = new URL('/auth/identity', platformUrl);
    url.searchParams.set('email', email);
    url.searchParams.set('desktop_origin', window.location.origin);
    const popup = window.open('about:blank', '_blank', 'popup=yes,width=500,height=600,scrollbars=yes');
    if (!popup) {
        throw new Error('Identity popup blocked');
    }

    let cancel;
    const promise = new Promise((resolve, reject) => {
        let timer;
        let timeout;
        let settled = false;
        const finish = (result, cancelled = false) => {
            if (settled) return;
            settled = true;
            window.removeEventListener('message', onMessage);
            window.clearInterval(timer);
            window.clearTimeout(timeout);
            if (!popup.closed) popup.close();
            if (result?.success && typeof result.token === 'string' && result.token && result.user?.id) {
                resolve(result);
            } else {
                const error = new Error(cancelled ? 'Identity login cancelled' : 'Identity login failed');
                error.code = cancelled ? 'login_cancelled' : 'login_failed';
                reject(error);
            }
        };
        const onMessage = event => {
            if (event.origin !== url.origin || event.source !== popup
                || event.data?.type !== 'nucleus:identity-login') return;
            finish(event.data.result);
        };
        cancel = () => finish(null, true);
        window.addEventListener('message', onMessage);
        timer = window.setInterval(() => {
            if (popup.closed) cancel();
        }, 300);
        timeout = window.setTimeout(() => finish(null), 600000);
        try {
            popup.location.replace(url.href);
            popup.focus();
        } catch {
            finish(null);
        }
    });
    return { promise, cancel };
}
